import { render } from "./homeData.vue?vue&type=template&id=01a75bfc&scoped=true"
import script from "./homeData.vue?vue&type=script&lang=js"
export * from "./homeData.vue?vue&type=script&lang=js"

import "./homeData.vue?vue&type=style&index=0&id=01a75bfc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01a75bfc"]])

export default __exports__